import React, { Component } from 'react'
import PropTypes from 'prop-types'
import ReactGA from 'react-ga'
import { Helmet } from 'react-helmet';
import { Route } from 'react-router-dom'

interface iLocation {
    pathname: string, search: string, title?: string, origin?: string
}

interface iProps {
  location: iLocation
  options: {}
}

class GoogleAnalytics extends Component<iProps> {
  componentDidMount () {
    this.logPageChange(
      this.props.location.pathname,
      this.props.location.search
    )
  }

  componentDidUpdate ({ location: prevLocation }:iProps) {
    const { location: { pathname, search } } = this.props
    const isDifferentPathname = pathname !== prevLocation.pathname
    const isDifferentSearch = search !== prevLocation.search

    if (isDifferentPathname || isDifferentSearch) {
      setTimeout(() => {
        this.logPageChange(pathname, search)
      }, 500)
    }
  }

  logPageChange (pathname: string, search: string= '') {
    const page = pathname + search
    const { location }: {location: iLocation} = window
    ReactGA.set({
      page,
      location: `${location.origin}${page}`,
      ...this.props.options
    })
    ReactGA.pageview(page,undefined,location.title)
  }

  render () {
    return null
  }
}

const RouteTracker = ({title}: {title: string}) => {
  return (<>
    <Helmet>
      <title>{title}</title>
    </Helmet>
    <Route component={GoogleAnalytics} />
  </>)
}

const init = (options = {}) => {
  // const env = window._env_ || {}
  const isGAEnabled = !!"UA-159825895-1"

  if (isGAEnabled) {
    ReactGA.initialize(
      "UA-159825895-1", {
        debug: false,
        titleCase: true,
        ...options
      }
    )
  }

  return isGAEnabled
}

export default {
  GoogleAnalytics,
  RouteTracker,
  init
}